import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { IMainstreetEvent } from '../classes';
import { calendarDispatch } from '../calendar'
import { setMonthFilter } from '../actions';

interface ICalendarFiltersMonth {
    selectedMonthFilter: string;
}

class CalendarFiltersMonth extends React.Component<ICalendarFiltersMonth, any>{
    monthList: Array<any>;

    constructor(props) {
        super(props);
        let allMonth = [{ text: 'All Months', filterMonth: null }];
        var monthCounter = moment();
        this.monthList = allMonth.concat(_.times(12, (month) => {
            let monthToAdd = {
                text: monthCounter.format('MMMM YYYY'), filterMonth: monthCounter.startOf('month').format('YYYY-MM-DD')
            };

            monthCounter.add( 1, 'month' );
            return monthToAdd;
        }));

    }

    

    render() {
      //console.log( this.props.selectedMonthFilter );

        return (
            <div>
                <label>By Month</label>
                <select onChange={this.sendAction.bind(this)} value={this.props.selectedMonthFilter}>
                    {
                        this.monthList.map((month) => <option key={month.filterMonth} value={month.filterMonth}> {month.text}</option>)
                    }
                </select>
            </div>
        )
    }
    sendAction(e) {
        //up
        moment(e.target.value)

        console.log(e.target.value);
        calendarDispatch()(setMonthFilter(e.target.value));

    }
};

export default CalendarFiltersMonth;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/filters/calendar-filters-month.tsx